<template>

    <!-- Main section start -->
    <main-section></main-section>
    <!-- Main section end -->

    <!-- About section start -->
    <about-section></about-section>
    <!-- About section end -->

    <!-- Services section start -->
    <service-section></service-section>
    <!-- Services section end -->


    <!-- Contact section start -->
    <contact-section></contact-section>
    <!-- Contact section end -->

    <!-- WhatsApp Floating Icon start -->
    <a :href="'https://wa.me/' + wppNumber" class="whatsapp-float" target="_blank">
        <i class="fab fa-whatsapp"></i>
    </a>
    <!-- WhatsApp Floating Icon end -->

</template>

<script>
import MainSection from '@/sections/MainSection.vue';
import AboutSection from '@/sections/AboutSection.vue';
import ServiceSection from '@/sections/ServiceSection.vue';
import ContactSection from '@/sections/ContactSection.vue';

export default {
    components: {
        MainSection,
        AboutSection,
        ServiceSection,
        ContactSection,
    },
    data() {
        return {
            wppNumber: '17864138919',
        }
    }
}
</script>

<style scoped>
@import '~@fortawesome/fontawesome-free/css/all.css';

.whatsapp-float {
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 40px;
    right: 40px;
    background-color: #25d366;
    color: #FFF;
    border-radius: 50px;
    text-align: center;
    font-size: 30px;
    box-shadow: 2px 2px 3px #999;
    z-index: 1000; 
    display: flex;
    align-items: center;
    justify-content: center;
}

.whatsapp-float i {
    font-size: 30px;
}
</style>